import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import PrefixedText from 'components/common/PrefixedText/PrefixedText'
import style from './InfoMessage.module.scss'

const InfoMessage = ({ className, label, prefix, suffix, type }) => {
  const { color, colabelNeutralMid, colabelNeutralDark } = useContext(ClientContext)

  return (
    <div
      className={classNames(style['info-message'], style[type], className)}
      style={color && {
        borderColor: colabelNeutralMid,
        color: colabelNeutralDark
      }}
    >
      <PrefixedText prefix={prefix} text={label} />
      {suffix && <div className={style.suffix}>{suffix}</div>}
    </div>
  )
}

export default InfoMessage
